import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk, RootState } from '../store';
import { cloneDeep } from 'lodash';
import { ReportSchedule, getReportSchedules, updateReportSchedule, setActive } from '../../api/reportSchedule';
import { ReportScheduleSlice, EditReportScheduleSlice } from './types';
import { notUndefined } from '../../lib/typeCheck';

const initialState: ReportScheduleSlice[] = [];

export const reportSchedulesSlice = createSlice({
  name: 'reportSchedules',
  initialState,
  reducers: {
    loadReportSchedules: (state, action: PayloadAction<ReportSchedule[]>) => {
      return action.payload.map((reportSchedule, index) => {
        let combined: ReportScheduleSlice = {
          ...cloneDeep(reportSchedule),
          id: index,
          saved: true
        }
        return combined
      })
    },
    editReportSchedule: (state, action: PayloadAction<EditReportScheduleSlice>) => {
      const reportSchedule = state.find(reportSchedule => reportSchedule.id === action.payload.id);
      if (notUndefined(action.payload.recipients)) reportSchedule.recipients = action.payload.recipients;
      if (notUndefined(action.payload.period)) reportSchedule.period = action.payload.period;
      if (notUndefined(action.payload.template_id)) reportSchedule.template_id = action.payload.template_id;
      if (notUndefined(action.payload.active)) reportSchedule.active = action.payload.active;
    }
  }
});

export const { loadReportSchedules, editReportSchedule } = reportSchedulesSlice.actions;

export const fetchReportSchedules = (station_id: number): AppThunk => async (dispatch, getState) => {
  const { user } = getState()
  
  try {
    const reportSchedules = await getReportSchedules(user.api_key, station_id)
    
    if (reportSchedules.length > 0) {
      dispatch(loadReportSchedules(reportSchedules));
    }
    
  } catch (err) {
    console.error(err.toString())
  }
}

export const toggleActive = (id: number): AppThunk => async (dispatch, getState) => {
  const { user, reportSchedules } = getState()
  
  const scheduled_report = reportSchedules.filter((reportSchdule) => reportSchdule.id === id)[0]
  const new_active = scheduled_report.active == 1? 0 : 1
  try {
    dispatch(editReportSchedule({id: scheduled_report.id, active: new_active}))
    await setActive(user.api_key, scheduled_report.report_schedule_id, new_active)
  } catch (err) {
    console.error(err.toString())
  }
}

export const saveReportSchedule = (id: number): AppThunk => async (dispatch, getState) => {
  const { user, reportSchedules } = getState()
  
  const reportSchedule = reportSchedules.filter((reportSchedule) => reportSchedule.id === id)[0]
  
  try {
  
    const result = await updateReportSchedule(user.api_key, reportSchedule)

  } catch (err) {
    console.error(err.toString())
  }
}

export const selectAllReportSchedules = (state: RootState) => {
  return state.reportSchedules;
}

export default reportSchedulesSlice.reducer;
